import React from 'react'

const EditStaff = () => {
  return (
    <div>EditStaff</div>
  )
}

export default EditStaff